var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "startNewAppModal",
    attrs: {
      id: "start-application-modal",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "md",
      "footer-close-button": false,
    },
    on: { hide: _vm.resetModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("global.actions.startNewApplication")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("global.actions.startApplicationNewBroker", {
                      agent: _vm.givenName + " " + _vm.familyName,
                      brokerage: _vm.brokerageName,
                    })
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "w-100", attrs: { id: "btn-container" } },
              [
                _c(
                  "b-row",
                  { staticClass: "d-flex justify-content-between" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "auto" } },
                      [
                        _c("simple-button", {
                          staticClass: "order-1",
                          attrs: {
                            id: "back",
                            text: _vm.$t("global.words.cancel"),
                            type: "white",
                          },
                          on: { click: _vm.closeModal },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "auto" } },
                      [
                        _c(
                          "simple-button",
                          {
                            staticClass: "confirm",
                            attrs: { loading: _vm.loading },
                            on: { click: _vm.startApplication },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("global.actions.startNewApplication")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }